// @flow
import Box from "@mui/material/Box";
import dayjs from "dayjs";
import React, { useMemo } from 'react';
import { useTranslation } from "react-i18next";
import DataGridWrapper from "../../../components/mui/grids/dataGridWrapper/dataGridWrapper";
import EditableMUICellValidation
    from "../../../components/mui/grids/editableMUICellValidation/editableMUICellValidation";
import EditableMUIDataGrid from "../../../components/mui/grids/editableMUIDataGrid/editableMUIDataGrid";
import EditableMuiDataGridCustomFields
    from "../../../components/mui/grids/editableMUIDataGridCustomFields/editableMUIDataGridCustomFields";
import useUserData from "../../../hooks/user/useUserData";
import useSalaryIncreaseRate from "../hooks/useSalaryIncreaseRate";
import { RATES } from "../locales/namespaces";
import useExtraContributionRate from "../hooks/useExtraContributionRate";

type Props = {};

const ExtraContributionRate = (props: Props) => {
    const { t } = useTranslation(RATES)
    const {
        data,
        isLoading,
        total,
        store,
        remove,
        update,
        page,
        pageSize,
        onPaginationModelChange,
        onSortModelChange,
        onFilterModelChange,
    } = useExtraContributionRate()

    const { dateFormat } = useUserData()

    const newRowModel = {
        Description: '',
        FromDt: dayjs(),
    }

    const columns = useMemo(() => [

        {
            field: 'Description',
            headerName: t('Extra Contribution Rate'),
            minWidth: 150, flex: 1,
            editable: true,
            type: 'number',
            valueGetter: (value, row, column, apiRef) => value ? Number(value) : 0,
            preProcessEditCellProps: (params) => {
                const inputValue = params.props.value
                const inputMinLength = Number(params.props.value) < 0;
                if (!inputValue && inputValue !== 0) {
                    return { ...params.props, error: t('Required') };
                } else if (inputMinLength) {
                    return { ...params.props, error: t('Insert a positive number') };
                }
                return { ...params.props, error: null }; // No error
            },
            renderEditCell: (params) => {
                return (
                    <EditableMUICellValidation {...params}>
                        <Box>
                            <EditableMuiDataGridCustomFields
                                type={'number'}
                                params={params}
                                name={'Description'}
                            />
                        </Box>
                    </EditableMUICellValidation>
                )
            },
        },
        {
            field: 'FromDt',
            headerName: t('From Date'),
            minWidth: 120, flex: 1,
            align: 'center',
            editable: true,
            type: 'date',
            valueFormatter: (value) => value ? dayjs(value).format(dateFormat) : null,
            preProcessEditCellProps: (params) => {
                const inputValue = params.props.value
                const hasValue = inputValue ? typeof inputValue !== 'string' ? dayjs(inputValue).format(dateFormat) : inputValue : null
                const validDate = inputValue ? typeof inputValue !== 'string' ? inputValue?.isValid() : true : false
                if (!hasValue) {
                    return { ...params.props, error: t('Required') };
                } else if (!validDate) {
                    return { ...params.props, error: t('Insert a valid date') };
                }
                return { ...params.props, error: null }; // No error
            },
            renderEditCell: (params) => {
                return (
                    <EditableMUICellValidation {...params}>
                        <Box>
                            <EditableMuiDataGridCustomFields
                                type={'datePicker'}
                                params={params}
                                name={'FromDt'}
                                otherInputParams={{
                                    inputFormat: dateFormat,
                                    format: dateFormat,
                                    slotProps: {
                                        textField: {
                                            size: 'small',
                                            variant: 'standard'
                                        }
                                    },
                                    views: ['year', 'month', 'day']
                                }}
                            />
                        </Box>
                    </EditableMUICellValidation>
                )
            },
        },

    ], [t, dateFormat])
    return (
        <Box className="specialties_index">
            <DataGridWrapper sx={{ height: 600, maxWidth: '700px' }}>
                <EditableMUIDataGrid
                    data={data}
                    columns={columns}
                    loading={isLoading}
                    newRowModel={newRowModel}
                    store={store}
                    remove={remove}
                    update={update}
                    dataGridProOtherProps={{
                        pagination: true,
                        paginationModel: { page, pageSize },
                        paginationMode: "server",
                        onPaginationModelChange: onPaginationModelChange,
                        rowCount: Number(total),
                        pageSizeOptions: [5, 10, 15, 20, 50, 100],
                        sortingMode: "server",
                        onSortModelChange: (sortModel) => onSortModelChange(sortModel),
                        filterMode: "server",
                        onFilterModelChange: onFilterModelChange,
                        initialSortModel: [{ name: 'FromDt', direction: 'ascending' }],
                    }}
                />
            </DataGridWrapper>
        </Box>
    );
};
//
export default ExtraContributionRate
// export default withPermissionHOC(Rates, [access_skills])